import { TAG_DATA } from './tagData.js';
export const TAG_FAMILIES = TAG_DATA.families;
/** All customer tags, in data-dictionary order (family, then registry order). */
export const TAGS = TAG_DATA.tags;
const BY_TAG = new Map(TAGS.map((t, i) => [t.tag, { ...t, order: i }]));
export function tagInfo(tag) {
    return BY_TAG.get(tag);
}
export function tagFamilyLabel(family) {
    return TAG_FAMILIES.find((f) => f.key === family)?.label ?? family;
}
/** Sort tag names into dictionary order; unknown tags go last, alphabetically. */
export function tagsInFamilyOrder(tags) {
    const order = (t) => BY_TAG.get(t)?.order ?? Number.POSITIVE_INFINITY;
    return [...tags].sort((a, b) => order(a) - order(b) || a.localeCompare(b));
}
//# sourceMappingURL=registry.js.map